import React from 'react';

const Pronouns = () => {
  return (
    <div className="gadject-container">
      <div className="gadject-head">What is a Pronoun (Àrọpò Orúkọ)?</div>

      <div className="gadject-stuff">
        <div className="gadject-body">
          A pronoun simply is a word that can be used to replace a noun or noun phrase in a sentence{' '}
          <br />
          For example;
        </div>

        <div className="noun-table-container">
          <div className="adverb -noun">
            <div className="noun-table">
              <p>I</p>
              <p>me</p>
              <p>you</p>
              <p>she</p>
              <p>he</p>
              <p>them</p>
              <p>we</p>
              <p>they</p>
            </div>
            <div className="noun-table">
              <p>emi</p>
              <p>mi</p>
              <p>ìwọ</p>
              <p>òun</p>
              <p>òun</p>
              <p>àwọn</p>
              <p>àwa</p>
              <p>àwọn</p>
            </div>
          </div>

          <div className="adverb -noun">
            <div className="noun-table">
              <p>us</p>
              <p>my</p>
              <p>his</p>
              <p>hers</p>
              <p>their</p>
              <p>our</p>
              <p>yours</p>
              <p>theirs</p>
            </div>
            <div className="noun-table">
              <p>àwa</p>
              <p>mi</p>
              <p>tòun</p>
              <p>tòun</p>
              <p>tàwọn</p>
              <p>tàwa</p>
              <p>irẹ</p>
              <p>tàwọn</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pronouns;
